export default {"src":"/_next/static/media/Accountability.9c905885.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};